import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function IdPhotoPrivacyPolicyEn() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # Privacy Policy

"Passport Photo-ID Photo Snap" (hereinafter referred to as "this app") respects users' privacy and is committed to protecting personal information. This app does not collect users' personal information and takes measures to protect users' data. This Privacy Policy (hereinafter referred to as "this Policy") sets forth the handling of information in this app.

## Article 1 (Personal Information Collection and Management Policy)

This app does not collect any personal information (such as name, address, phone number, etc.) from users. All functions within the app are designed on the premise that no personal information will be collected. Furthermore, to protect users' privacy, we do not collect or store any information that could identify individuals.

## Article 2 (User Data Storage)

In this app, all scan results are stored only on the user's device and are not saved to external servers. Therefore, neither this app nor its developers have access to the data scanned by users. We guarantee that this data will not be shared with third parties and will be securely stored on the user's device.

## Article 3 (Advertisement Delivery)

This app delivers advertisements through Google AdMob. During the advertisement delivery process, data may be automatically collected by Google's system for advertising optimization, but this data is managed according to Google's privacy policy. This app does not retain any personal information related to advertisement delivery. For details, please refer to Google's privacy policy.

## Article 4 (User Rights and Data Management)

This app ensures that users have complete control over their data. Users can delete app data at any time, and this app will not transmit data externally without user action. Additionally, since personal information is not used when using this app according to the Terms of Service, requests for information disclosure, correction, deletion, or suspension of use are not applicable.

## Article 5 (Changes to Privacy Policy)

This app may periodically review and change this Policy to improve user privacy protection in response to legal amendments or changes in app functionality. When changes occur, we will notify users by posting the latest Privacy Policy within this app, which will take effect immediately upon posting. Users are requested to check this Policy periodically.

## Article 6 (Contact Information)

For inquiries or questions about this Policy, please contact us at:

Email: linappworks@gmail.com
  `;

  return (
    <Container>
      <Content>
        <Title>Privacy Policy</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default IdPhotoPrivacyPolicyEn; 